import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getOrganizationContextNotifications,
  markAllOrganizationContextNotificationsRead,
  markOrganizationContextNotificationRead,
} from "@/services/organizationContextNotificationsService";

const queryKey = ["organization-context", "notifications"] as const;

export function useOrganizationContextNotifications(enabled = true) {
  const queryClient = useQueryClient();
  const invalidate = () => queryClient.invalidateQueries({ queryKey });
  return {
    notifications: useQuery({ queryKey, queryFn: getOrganizationContextNotifications, enabled, staleTime: 30_000 }),
    markRead: useMutation({ mutationFn: markOrganizationContextNotificationRead, onSuccess: invalidate }),
    markAllRead: useMutation({ mutationFn: markAllOrganizationContextNotificationsRead, onSuccess: invalidate }),
  };
}
